import React from "react"
import { View, Text, Window, List } from "react-ame-components"

export class ListExample extends React.Component {
  state = {
    ListItems: [{ title: "Compras" }, { title: "Saldo" }, { title: "Extrato" }],
  }

  goTo = index => {
    console.log(index)
  }

  render() {
    return (
      <Window>
        <View padding="medium">
          <Text fontSize="medium">Componente List</Text>
        </View>
        <View padding="small">
          <List
            items={this.state.ListItems}
            onItemPress={i => this.goTo(i)}
          />
        </View>
      </Window>
    )
  }
}
